'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoComplete = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _rcSelect = require('rc-select');

var _rcSelect2 = _interopRequireDefault(_rcSelect);

var _AutoComplete = require('./AutoComplete.style');

var _FieldWrapper = require('../FieldWrapper/FieldWrapper');

var _FieldWrapper2 = _interopRequireDefault(_FieldWrapper);

var _helpers = require('../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Basic autocomplete input. Pass options as array of strings or array of
 * objects with label/value keys. You can pass a custom filter function to
 * filter available options. Default filter by value.
 */
var AutoComplete = function AutoComplete(_ref) {
  var allowClear = _ref.allowClear,
      className = _ref.className,
      description = _ref.description,
      error = _ref.error,
      focused = _ref.focused,
      label = _ref.label,
      multiple = _ref.multiple,
      name = _ref.name,
      onClear = _ref.onClear,
      options = _ref.options,
      prefixCls = _ref.prefixCls,
      animation = _ref.animation,
      transitionName = _ref.transitionName,
      choiceTransitionName = _ref.choiceTransitionName,
      dropdownStyle = _ref.dropdownStyle,
      dropdownMenuStyle = _ref.dropdownMenuStyle,
      tokenSeparators = _ref.tokenSeparators,
      maxTagLength = _ref.maxTagLength,
      getPopupContainer = _ref.getPopupContainer,
      getInputElement = _ref.getInputElement,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['allowClear', 'className', 'description', 'error', 'focused', 'label', 'multiple', 'name', 'onClear', 'options', 'prefixCls', 'animation', 'transitionName', 'choiceTransitionName', 'dropdownStyle', 'dropdownMenuStyle', 'tokenSeparators', 'maxTagLength', 'getPopupContainer', 'getInputElement']);
  return _react2.default.createElement(
    _FieldWrapper2.default,
    {
      className: className,
      description: description,
      error: error,
      label: label,
      labelFor: name
    },
    _react2.default.createElement(
      _rcSelect2.default,
      (0, _extends3.default)({}, rest, {
        allowClear: allowClear && !rest.value,
        combobox: !multiple,
        defaultActiveFirstOption: true,
        dropdownAlign: { offset: [0, 0] },
        dropdownClassName: className,
        dropDownMatchSelectWidth: true,
        labelInValue: false,
        multiple: false,
        notFoundContent: null,
        optionFilterProp: 'value',
        showSearch: true,
        showArrow: true,
        tags: multiple
      }),
      (0, _helpers.normalizeOptions)(options).map(function (option) {
        return _react2.default.createElement(
          _rcSelect.Option,
          {
            key: 'select-' + name + '-option-' + option.value,
            label: option.label,
            value: option.value,
            option: option
          },
          option.label
        );
      })
    ),
    onClear && rest.value && rest.value.length > 0 && _react2.default.createElement('div', { className: 'clear-value rc-select-selection__clear', onClick: onClear })
  );
};

exports.AutoComplete = AutoComplete;
AutoComplete.propTypes = {
  /**
   * Allow clearing of autocomplete value. Displays 'x' icon on right side of
   * input. This ONLY displays and functions when NOT explicitly passing in
   * value. If you are explicitly passing in value see `onClear` prop.
   */
  allowClear: _propTypes2.default.bool,
  /**
   * className for glamorous styles
   * @ignore
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * Default value for autocomplete
   */
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  /**
   * Helper description for tooltip
   */
  description: _propTypes2.default.string,
  /**
   * Whether or not this input is disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Error message for autocomplete. Alters autocomplete style and
   * displays error message if set.
   */
  error: _propTypes2.default.string,
  /**
   * Custom filter function for autocomplete or true for default
   * filter function. Filter function determines which options to show when
   * user types into autocomplete. Default filter function filters options
   * by value. Filter function parameters: `(inputValue, OptionChild)`.
   * Option props available at `OptionChild.props.option` for filtering.
   */
  filterOption: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
  /**
   * Field label text to display above autocomplete
   */
  label: _propTypes2.default.string,
  /**
   * Allow multiple values or not. When false, value will be a string.
   * When true, value will be an array of strings. Multiple values will
   * automatically be unique.
   */
  multiple: _propTypes2.default.bool,
  /**
   * Field name in form
   */
  name: _propTypes2.default.string,
  /**
   * Function to call on autocomplete blur
   */
  onBlur: _propTypes2.default.func,
  /**
   * Function to call on autocomplete change
   */
  onChange: _propTypes2.default.func,
  /**
   * Function to handle clearing when passing
   * in value as prop. This is ONLY displayed
   * and called when explicitly passing in value.
   */
  onClear: _propTypes2.default.func,
  /**
  * Function to call when option is deselected.
  */
  onDeselect: _propTypes2.default.any,
  /**
   * Function to call on autocomplete focus
   */
  onFocus: _propTypes2.default.func,
  /**
   * Function to call when typing into AutoComplete.
   * Gets input value as parameter.
   */
  onSearch: _propTypes2.default.func,
  /**
   * Function to call when option is selected.
   */
  onSelect: _propTypes2.default.any,
  /**
   * Which part of the option object to display
   * when selected
   * @type {[type]}
   */
  optionLabelProp: _propTypes2.default.string,
  /**
   * Autocomplete source options. Array of strings for equal value/label
   * options or array of `{ value, label }` objects.
   * label can be any React node.
   */
  options: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.any,
    value: _propTypes2.default.any
  }))]).isRequired,
  /**
   * Placeholder text for autocomplete
   */
  placeholder: _propTypes2.default.string,
  /**
   * Selected value
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
};
AutoComplete.defaultProps = {
  allowClear: false,
  disabled: false,
  filterOption: function filterOption(input, child) {
    return child.props.value.toLowerCase().indexOf(input.toLowerCase()) > -1;
  },
  optionLabelProp: 'label'
};

exports.default = (0, _helpers.withFocus)((0, _glamorous2.default)(AutoComplete)(_AutoComplete.defaultStyle, _AutoComplete.mapPropsAndThemeToStyle));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/Select/AutoComplete.js
// module id = 484
// module chunks = 0